// extracted by mini-css-extract-plugin
export var buttonContainer = "_6b-1";
export var fontSizeSelect = "_6b-3";
export var formatSelect = "_6b-2";
export var formats = "_6b-4";
export var hidden = "_6b-5";
export var icon = "_6b-6";
export var select = "_6b-0";